var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var arabam;
(function (arabam) {
    var collectRecommendationController = /** @class */ (function () {
        function collectRecommendationController(http, $scope, $element) {
            this.http = http;
            this.$scope = $scope;
            this.$element = $element;
            this.collectRecommendationList = [];
            this.init();
        }
        collectRecommendationController.prototype.init = function () {
            var self = this;
            window.addEventListener("collect-recommendation-adverts-fetched", function () {
                self.setcollectRecommendationList();
            });
        };
        collectRecommendationController.prototype.setcollectRecommendationList = function () {
            var _this = this;
            var _a, _b;
            this.collectRecommendationList = (_b = (_a = window.recommendationAdverts) === null || _a === void 0 ? void 0 : _a.map) === null || _b === void 0 ? void 0 : _b.call(_a, function (item) {
                return (__assign(__assign({}, item), { Title: _this.fixWordsLength(item.Title) }));
            });
            this.$scope.$apply();
        };
        collectRecommendationController.prototype.fixWordsLength = function (text) {
            var words = text.split(' ');
            var newText = "";
            for (var _i = 0, words_1 = words; _i < words_1.length; _i++) {
                var word = words_1[_i];
                if (word.length > 20) {
                    var firstWord = word.substring(0, 20);
                    var secondWords = word.substring(20);
                    newText += firstWord + "-" + this.fixWordsLength(secondWords);
                }
                else {
                    newText += word + " ";
                }
            }
            return newText.trim();
        };
        collectRecommendationController.$inject = ["$http", "$scope", "$element"];
        return collectRecommendationController;
    }());
    angular.module("arabam").controller("collectRecommendationController", collectRecommendationController);
})(arabam || (arabam = {}));
